import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Card,Checkbox,FormControlLabel,IconButton,Slider,Stack,TextField,Typography } from "@mui/material";
import { useMask } from "@react-input/mask";
import { useContext,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../context/NewFormContext";
import { ChecklistType } from "../../types/checklist/types";

export default function Scoring() {
  const { t } = useTranslation("translation");
  const { modelo, itemRange, setItemRange, checkedScoring, setCheckedScoring, setModelo } = useContext(NewFormContext);
  const inputRef = useMask({ mask: "___", replacement: { _: /\d/ } });

  useEffect(() => {
    if (!modelo?.range) return;

    setCheckedScoring(true);

    setItemRange(
      Object.entries(modelo.range).map(([key, value], index) => ({
        index: index,
        name: value || "",
        range: Number(key)
      }))
    );
  }, [modelo, setCheckedScoring, setItemRange]);

  useEffect(() => {
    if (modelo?.range) {
      const objs = [];
      Object.entries(modelo.range)?.forEach(([key, value], i) => {
        objs.push({
          index: i,
          name: value || "",
          range: Number(key),
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const marks = [
    { value: 0, label: 0 },
    { value: 5, label: "|" },
    { value: 10, label: 10 },
    { value: 15, label: "|" },
    { value: 20, label: 20 },
    { value: 25, label: "|" },
    { value: 30, label: 30 },
    { value: 35, label: "|" },
    { value: 40, label: 40 },
    { value: 45, label: "|" },
    { value: 50, label: 50 },
    { value: 55, label: "|" },
    { value: 60, label: 60 },
    { value: 65, label: "|" },
    { value: 70, label: 70 },
    { value: 75, label: "|" },
    { value: 80, label: 80 },
    { value: 85, label: "|" },
    { value: 90, label: 90 },
    { value: 95, label: "|" },
    { value: 100, label: 100 },
  ];

  const valueLabelFormat = (value: number) => {
    const title = itemRange?.find((e) => e.range === value)?.name;
    if (!title) return <></>;
    return (
      <span style={{ backgroundColor: "#3F51B5", color: "white" }} className="tag">
        {title}
      </span>
    );
  };

  return (
    <Card sx={{ width: "100%", padding: 2 }}>
      <Stack padding={4} width="100%" direction="column" justifyContent="center" alignItems="center" spacing={3.5}>
        <Typography color="textDisabled" variant="h5" textAlign="center" fontWeight={600} width="100%">
          Configuração de scoring
        </Typography>
        <FormControlLabel
          control={<Checkbox onChange={(event) => setCheckedScoring(event.target.checked)} checked={checkedScoring} />}
          label={t("formDetails.range_scoring.Habilitar_range_Scoring")}
        />
        {checkedScoring && (
          <Stack width={"100%"} direction="column" justifyContent="center" alignItems="center" spacing={5}>
            <Slider
              max={100}
              min={0}
              valueLabelFormat={valueLabelFormat}
              defaultValue={100}
              getAriaLabel={() => itemRange?.[0]?.name || ""}
              valueLabelDisplay="on"
              value={itemRange?.map((e) => e.range)}
              marks={marks}
            />
            <Stack width={"100%"} direction="column" justifyContent="center" alignItems="center" spacing={1}>
              {itemRange?.map((e, i) => (
                <Stack sx={{ width: "100%" }} direction="row" justifyContent="center" alignItems="center" spacing={0.5} key={i}>
                  <TextField
                    size="small"
                    required
                    sx={{
                      ".MuiInputBase-input": {
                        padding: "10px 5px 10px 10px",
                      },
                    }}
                    fullWidth
                    label="Nome do range"
                    type="text"
                    value={itemRange[i].name}
                    onChange={(e) => {
                      const newState = itemRange?.map((item, index) => {
                        if (index === i) {
                          item.name = e.target.value;
                        }
                        return item;
                      });
                      setModelo((prev: ChecklistType) => {
                        const newRange: ChecklistType['range'] = {};
                        newState?.forEach((el) => {
                          newRange[el.range] = el.name;
                        });
                        return { ...prev, range: newRange };
                      });
                      setItemRange(newState);
                    }}
                  />
                  <TextField
                    size="small"
                    required
                    key={i}
                    sx={{
                      ".MuiInputBase-input": {
                        textAlign: "center",
                      },
                    }}
                    color={`${itemRange?.some((ele) => ele.range > 100) ? "error" : "primary"}`}
                    inputRef={inputRef}
                    slotProps={{
                      htmlInput: {
                        max: marks[20].label,
                        min: marks[0].label,
                        maxLength: 3,
                        type: "numeric",
                      },
                    }}
                    label="Valor do range"
                    value={itemRange[i].range}
                    onChange={(e) => {
                      const newState = itemRange?.map((item, index) => {
                        if (index === i) {
                          item.range = Number(e.target.value);
                        }
                        return item;
                      });
                      setModelo((prev: ChecklistType) => {
                        const newRange: ChecklistType['range'] = {};
                        newState?.forEach((el) => {
                          newRange[el.range] = el.name;
                        });
                        return { ...prev, range: newRange };
                      });
                      setItemRange(newState);
                    }}
                  />
                  {i === 0 ? (
                    <IconButton
                      size="large"
                      onClick={() => {
                        setItemRange([...itemRange, { index: itemRange.length, name: t("formDetails.range_scoring.Novo_Range"), range: 50 }]);
                        setModelo((prev: ChecklistType) => {
                          const newRange: ChecklistType['range'] = {};
                          [...itemRange, { index: itemRange.length, name: t("formDetails.range_scoring.Novo_Range"), range: 50 }].forEach((el) => {
                            newRange[el.range] = el.name;
                          });
                          return { ...prev, range: newRange };
                        });
                      }}
                      color="success">
                      <AddCircleIcon fontSize="large" />
                    </IconButton>
                  ) : (
                    <IconButton
                      size="large"
                      color="error"
                      onClick={() => {
                        setItemRange(itemRange?.filter((el) => el.index !== e.index));
                        setModelo((prev: ChecklistType) => {
                          const newRange: ChecklistType['range'] = {};
                          itemRange
                            ?.filter((el) => el.index !== e.index)
                            .forEach((el) => {
                              newRange[el.range] = el.name;
                            });
                          return { ...prev, range: newRange };
                        });
                      }}>
                      <RemoveCircleIcon fontSize="large" />
                    </IconButton>
                  )}
                </Stack>
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>
    </Card>
  );
}
